"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_google__plus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "7dc06aba-70b5-442e-a9e8-57c443b66f6c",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 159.86 101.03"
  }, props), /*#__PURE__*/React.createElement("title", null, "social-google-plus"), /*#__PURE__*/React.createElement("path", {
    id: "95ade48b-368d-4ab7-8c15-c09296b0cc50",
    "data-name": "4cc9f06a-00c5-43ef-9697-d53f220c77a9",
    d: "M66.7,146a50.51,50.51,0,1,1,34-87.78L85.91,72.86a29.66,29.66,0,1,0,3.48,41.8A27.17,27.17,0,0,0,94.46,106H66V85h50.06a50.64,50.64,0,0,1-39,60A45.09,45.09,0,0,1,66.7,146ZM176,100H158v18H145V100H128V87h17V69h13V87h17V99.8Z",
    transform: "translate(-16.14 -44.99)"
  }));
}

var _default = ic_google__plus;
exports.default = _default;